import { render } from "./EditFacilities.vue?vue&type=template&id=2de8410a"
import script from "./EditFacilities.vue?vue&type=script&lang=js"
export * from "./EditFacilities.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__